export const Environment = {
	Local: 'localhost',
	QA: 'qa',
	Production: 'production',
};

export const AppLinks = {
  QA: 'https://app.staging.unuhealth.org',
  Production: 'https://app.unuhealth.org/',
};

export const HostNames = {
  [Environment.Local]: [
    'localhost',
    '127.0.0.1',
    '10.0.2.2',
  ],
  [Environment.QA]: [
    AppLinks.QA,
  ],
  [Environment.Production]: [
    AppLinks.Production,
  ],
};
